import { FC, useState } from "react";
import { Box, Button } from "@mui/material";
import { toast } from "react-toastify";
import { toastOptions } from "config/constants";
import { useAppDispatch } from "config/hooks";
import accountsAPI from "api/accounts";
import { completeSignIn, signOutUser } from "reducers/auth";

interface NoAccountAccessProps {
  user: any;
}

const NoAccountAccess: FC<NoAccountAccessProps> = ({ user }) => {
  const dispatch = useAppDispatch();
  const [isChecking, setIsChecking] = useState<boolean>(false);

  const checkAgain = async () => {
    setIsChecking(true);
    try {
      const accounts = await accountsAPI.getAccounts();
      if (accounts.length === 0) {
        toast.info("You still don't have access to any account.", toastOptions);
        return;
      }
      // completeSignIn stores what it gets as state.auth.currentUser, which
      // holds the { data: user } response shape everywhere else.
      await dispatch(completeSignIn({ data: user }));
    } catch {
      toast.error("Could not check your access. Please try again.", toastOptions);
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <div className="h-100 bg-plum-plate bg-animation">
      <div className="d-flex h-100 justify-content-center align-items-center">
        <Box
          className="mx-auto app-login-box"
          sx={{ width: { xs: "100%", md: "66.66%" } }}
        >
          <div className="modal-dialog w-100 mx-auto">
            <div className="modal-content">
              <div className="modal-body">
                <div className="app-logo mx-auto mb-3" />
                <h4 className="text-center mb-3">No account access</h4>
                <p className="text-center">
                  Your user isn't linked to any Riivet account right now. If you
                  need access, ask an account owner to invite you.
                </p>
                <p className="text-center text-muted mb-0">
                  Signed in as {user.email}
                </p>
              </div>
              <div className="modal-footer clearfix">
                <div className="float-left">
                  <a
                    href="#/signin"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(signOutUser());
                    }}
                  >
                    Sign in with another account
                  </a>
                </div>
                <div className="float-right">
                  <Button
                    variant="contained"
                    size="large"
                    disabled={isChecking}
                    onClick={checkAgain}
                  >
                    {isChecking ? "Checking..." : "Check again"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </div>
    </div>
  );
};

export default NoAccountAccess;
